export default __webpack_public_path__ + "static/media/cassandralogo.62ca6f5f.png";